import { createAction, props } from '@ngrx/store';
import { IntegrationLookup } from '../../models/integration-lookup.model';
import { IntegrationVersionedConfigFile } from '../../models/integration-config-file.model';
import { IntegrationArtifact } from '../../models/integration-artifact';
import {
    ClientIntegrationIdentifier,
    ClientIntegrationVersionIdentifier
} from '../../models/client-integration-identifier';
import { PublishedVersions, SetPublishedVersionRequest } from '../../models/integration/published-version.model';

export enum IntegrationManagev2ActionsEnum {
    GetIntegrationLookup = '[INTEGRATIONS MANAGE V2] Get all Integration Lookup',
    SetIntegrationLookup = '[INTEGRATIONS MANAGE V2] Set all Integration Lookup',
    GetConfigFiles = '[INTEGRATIONS MANAGE V2] Get all config files',
    SetConfigFiles = '[INTEGRATIONS MANAGE V2] Set all config files',
    GetFileContent = '[INTEGRATIONS MANAGE V2] Get file json content',
    SetFileContent = '[INTEGRATIONS MANAGE V2] Set file json content',
    SetIsSaving = '[INTEGRATIONS MANAGE V2] Set Is saving ',
    SaveConfigFile = '[INTEGRATIONS MANAGE V2] Save config file',
    DeleteConfigFile = '[INTEGRATIONS MANAGE V2] Delete config file',
    AddConfigFile = '[INTEGRATIONS MANAGE V2 ADD] Add config file',
    NewIntegration = '[INTEGRATIONS MANAGE V2 NEW] Add new Integration',
    DownloadConfigFile = '[INTEGRATIONS MANAGE V2] Download config file',
    GetVersions = '[INTEGRATIONS MANAGE V2] Get all version and config files of latest version',
    SetVersions = '[INTEGRATIONS MANAGE V2] Set all versions on first load',
    CreateVersion = '[INTEGRATIONS MANAGE V2] Create new version',
    SetPublishedVersion = '[INTEGRATIONS MANAGE V2] Set Published Version',
    GetAllPublishedVersions = '[INTEGRATIONS MANAGE V2] Get All Published Versions',
    SetAllPublishedVersions = '[INTEGRATIONS MANAGE V2] Set All Published Versions',
    GetVersionsOnCreate = '[INTEGRATIONS MANAGE V2] Get Versions On Create new version'
}

export const getIntegrationLookup = createAction(IntegrationManagev2ActionsEnum.GetIntegrationLookup);

export const setIntegrationLookup = createAction(
    IntegrationManagev2ActionsEnum.SetIntegrationLookup,
    props<{ integrationLookup: IntegrationLookup }>()
);

export const getConfigFiles = createAction(
    IntegrationManagev2ActionsEnum.GetConfigFiles,
    props<{ identifier: ClientIntegrationVersionIdentifier }>()
);

export const setConfigFiles = createAction(IntegrationManagev2ActionsEnum.SetConfigFiles, props<{ files: string[] }>());

export const getFileContent = createAction(
    IntegrationManagev2ActionsEnum.GetFileContent,
    props<{ config: IntegrationVersionedConfigFile }>()
);

export const setFileContent = createAction(IntegrationManagev2ActionsEnum.SetFileContent, props<{ content: string }>());

export const saveConfigFile = createAction(
    IntegrationManagev2ActionsEnum.SaveConfigFile,
    props<{ config: IntegrationVersionedConfigFile }>()
);

export const deleteConfigFile = createAction(
    IntegrationManagev2ActionsEnum.DeleteConfigFile,
    props<{ config: IntegrationVersionedConfigFile }>()
);

export const setIsSaving = createAction(IntegrationManagev2ActionsEnum.SetIsSaving, props<{ isSaving: boolean }>());

export const addConfigFile = createAction(
    IntegrationManagev2ActionsEnum.AddConfigFile,
    props<{ config: IntegrationVersionedConfigFile }>()
);

export const newIntegration = createAction(
    IntegrationManagev2ActionsEnum.NewIntegration,
    props<{ config: IntegrationVersionedConfigFile }>()
);

export const downloadConfigFile = createAction(
    IntegrationManagev2ActionsEnum.DownloadConfigFile,
    props<{ artifact: IntegrationArtifact }>()
);

export const getVersions = createAction(
    IntegrationManagev2ActionsEnum.GetVersions,
    props<{ identifier: ClientIntegrationVersionIdentifier }>()
);

export const setVersions = createAction(
    IntegrationManagev2ActionsEnum.SetVersions,
    props<{ versions: string[]; selectedVersion: string }>()
);

export const createVersion = createAction(
    IntegrationManagev2ActionsEnum.CreateVersion,
    props<{ identifier: ClientIntegrationVersionIdentifier }>()
);

export const setPublishedVersion = createAction(
    IntegrationManagev2ActionsEnum.SetPublishedVersion,
    props<{ request: SetPublishedVersionRequest }>()
);

export const getAllPublishedVersions = createAction(
    IntegrationManagev2ActionsEnum.GetAllPublishedVersions,
    props<{ identifier: ClientIntegrationIdentifier }>()
);

export const setAllPublishedVersions = createAction(
    IntegrationManagev2ActionsEnum.SetAllPublishedVersions,
    props<{ publishedVersions: PublishedVersions }>()
);

export const getVersionsOnCreate = createAction(
    IntegrationManagev2ActionsEnum.GetVersionsOnCreate,
    props<{ identifier: ClientIntegrationVersionIdentifier }>()
);

export const IntegrationManagev2Actions = {
    getIntegrationLookup,
    setIntegrationLookup,
    getConfigFiles,
    setConfigFiles,
    getFileContent,
    setFileContent,
    setIsSaving,
    saveConfigFile,
    deleteConfigFile,
    addConfigFile,
    newIntegration,
    downloadConfigFile,
    getVersions,
    setVersions,
    createVersion,
    setPublishedVersion,
    getAllPublishedVersions,
    setAllPublishedVersions,
    getVersionsOnCreate
};
